module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('scroller', [_c('div', {
    style: {
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    }
  }, [_c('div', {
    style: _vm.gradientTopStyle
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-0f699cc9!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-gradient/index.vue
// module id = 566
// module chunks = 0 1